var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanNameBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 11,
    viewBox: "0 0 141 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.40663C32.78 4.28103 99.8243 -1.12827 117.765 2.94547C118.455 3.10214 69.12 0.401661 34.275 9.5C77.745 4.619 122.595 5.13171 139.5 6.22378",
    stroke: "#6DD0CF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanNameBorder);
export default __webpack_public_path__ + "static/media/plan_name_border.4d4ee01cd15eda38a97dcf75c10857ef.svg";
export { ForwardRef as ReactComponent };